import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  GcIconComponent,
  GcTooltipComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { ResourcesService } from '../user/resources.service';

@Component({
  selector: 'app-resource-complete',
  imports: [GcIconComponent, GcTooltipComponent, IpoTranslatePipe, DatePipe],
  templateUrl: './resource-complete.component.html',
  styleUrl: './resource-complete.component.scss',
})
export class ResourceCompleteComponent {
  private readonly resourceService = inject(ResourcesService);
  selectedResource = toSignal(this.resourceService.getSelectedResource$());
}
